import Vue from 'vue'
import Router from 'vue-router'

import Login from '../components/Login.vue'
import SwitchVue from '../components/Switch.vue'
import Dashboard from '../modules/dashboard/Dashboard.vue'

import Contacts from '../modules/contacts/Index.vue'
import ContactsDashboard from '../modules/contacts/Dashboard.vue'

import Serevita from '../modules/serevita/Index.vue'
import SerevitaDashboard from '../modules/serevita/Dashboard.vue'

import SerevitaContract from '../modules/serevita/contract/Index.vue'
import SerevitaContractEdit from '../modules/serevita/contract/Edit.vue'

import SerevitaProtractor from '../modules/serevita/protractor/Index.vue'
import SerevitaProtractorEdit from '../modules/serevita/protractor/Edit.vue'

import SerevitaProtractorLink from '../modules/serevita/protractor-link/Index.vue'
import SerevitaProtractorLinkEdit from '../modules/serevita/protractor-link/Edit.vue'

import SerevitaTable from '../modules/serevita/table/Index.vue'
import SerevitaTableEdit from '../modules/serevita/table/Edit.vue'

import Fidelity from '../modules/fidelity/Index.vue'
import FidelityDashboard from '../modules/fidelity/Dashboard.vue'

import FidelityAccount from '../modules/fidelity/account/Index.vue'
import FidelityAccountEdit from '../modules/fidelity/account/Edit.vue'

import CheckinHome from '../modules/checkin/Index.vue'

import Checkin from '../modules/checkin/reservation/Index.vue'
import CheckinEdit from '../modules/checkin/reservation/Edit.vue'

import Config from '../modules/config/Index.vue'
import ConfigDashboard from '../modules/config/Dashboard.vue'

import ConfigAttribute from '../modules/config/attribute/Index.vue'
import ConfigAttributeEdit from '../modules/config/attribute/Edit.vue'
import ConfigAttributeImport from '../modules/config/attribute/Import.vue'

import ConfigTransporter from '../modules/config/transporter/Index.vue'
import ConfigTransporterEdit from '../modules/config/transporter/Edit.vue'

import ConfigPayment from '../modules/config/payment/Index.vue'
import ConfigPaymentEdit from '../modules/config/payment/Edit.vue'

import ConfigQueue from '../modules/config/queue/Index.vue'

import ConfigInvoiceTemplate from '../modules/config/invoice-template/Index.vue'
import ConfigInvoiceTemplateEdit from '../modules/config/invoice-template/Edit.vue'

import ConfigPdfTemplate from '../modules/config/pdf-template/Index.vue'
import ConfigPdfTemplateEdit from '../modules/config/pdf-template/Edit.vue'

import ConfigPaymentDeadline from '../modules/config/payment-condition/Index.vue'
import ConfigPaymentDeadlineEdit from '../modules/config/payment-condition/Edit.vue'

import ConfigRating from '../modules/config/rating/Index.vue'
import ConfigRatingEdit from '../modules/config/rating/Edit.vue'

import ConfigBranch from '../modules/config/branch/Index.vue'
import ConfigBranchEdit from '../modules/config/branch/Edit.vue'

import ConfigAuthorization from '../modules/config/authorizations/Index.vue'
import ConfigAuthorizationCreate from '../modules/config/authorizations/Create.vue'
import ConfigAuthorizationEdit from '../modules/config/authorizations/Edit.vue'

import Person from '../modules/person/Index.vue'
import PersonEdit from '../modules/person/Edit.vue'
import PersonImport from '../modules/person/Import.vue'

import CampaignIndex from '../modules/campaign/Index.vue'
import CampaignDashboard from '../modules/campaign/Dashboard.vue'

import EventIndex from '../modules/event/Index.vue'
import EventEdit from '../modules/event/Edit.vue'

import Audience from '../modules/campaign/audience/Index.vue'
import AudienceEdit from '../modules/campaign/audience/Edit.vue'

import Campaign from '../modules/campaign/campaign/Index.vue'
import CampaignEdit from '../modules/campaign/campaign/Edit.vue'
import CampaignPublicationDetail from '../modules/campaign/campaign/Detail.vue'

import CampaignTemplate from '../modules/campaign/template/Index.vue'
import CampaignTemplateEdit from '../modules/campaign/template/Edit.vue'

import Company from '../modules/company/Index.vue'
import CompanyEdit from '../modules/company/Edit.vue'
//import CompanyCreate from '../modules/company/Create.vue'

//import Banner from '../modules/banner/Index.vue'
//import BannerDashboard from '../modules/banner/Dashboard.vue'

//import BannerArea from '../modules/banner/area/Index.vue'
//import BannerAreaEdit from '../modules/banner/area/Edit.vue'

//import BannerAd from '../modules/banner/ad/Index.vue'
//import BannerAdEdit from '../modules/banner/ad/Edit.vue'

//import BannerTemplate from '../modules/banner/template/Index.vue'
//import BannerTemplateEdit from '../modules/banner/template/Edit.vue'

import Scope from '../modules/scope/Index.vue'
import ScopeEdit from '../modules/scope/Edit.vue'

import Calendar from '../modules/config/calendar/Index.vue'
import CalendarEdit from '../modules/config/calendar/Edit.vue'

import OpeningHour from '../modules/config/opening-hours/Index.vue'
import OpeningHourEdit from '../modules/config/opening-hours/Edit.vue'

import Agenda from '../modules/config/agenda/Index.vue'
import AgendaEdit from '../modules/config/agenda/Edit.vue'

import Closure from '../modules/config/closure/Index.vue'
import ClosureEdit from '../modules/config/closure/Edit.vue'

import Pass from '../modules/pass/Index.vue'
import PassEdit from '../modules/pass/Edit.vue'
import PassTemplate from '../modules/pass/IndexTemplate.vue'

import Shortlink from '../modules/shortlink/Index.vue'
import ShortlinkEdit from '../modules/shortlink/Edit.vue'

import Shop from '../modules/shop/Index.vue'
import ShopDashboard from '../modules/shop/Dashboard.vue'

import Brand from '../modules/shop/brand/Index.vue'
import BrandEdit from '../modules/shop/brand/Edit.vue'
import BrandImport from '../modules/shop/brand/Import.vue'

import Category from '../modules/shop/category/Index.vue'
import CategoryEdit from '../modules/shop/category/Edit.vue'
//import CategoryCreate from '../modules/shop/category/Create.vue'
import CategoryImport from '../modules/shop/category/Import.vue'
import CategoryTree from '../modules/shop/category/Tree.vue'

import Product from '../modules/shop/product/Index.vue'
import ProductEdit from '../modules/shop/product/Edit.vue'
import ProductImport from '../modules/shop/product/Import.vue'

import Inventory from '../modules/shop/inventory/Index.vue'
import InventoryEdit from '../modules/shop/inventory/Edit.vue'

import ProductType from '../modules/shop/type/Index.vue'
import ProductTypeEdit from '../modules/shop/type/Edit.vue'
import ProductTypeImport from '../modules/shop/type/Import.vue'

import ProductOption from '../modules/shop/option/Index.vue'
import ProductOptionEdit from '../modules/shop/option/Edit.vue'

import Voucher from '../modules/shop/voucher/Index.vue'
import VoucherEdit from '../modules/shop/voucher/Edit.vue'

import Giftcard from '../modules/shop/giftcard/Index.vue'
import GiftcardEdit from '../modules/shop/giftcard/Edit.vue'

import Discount from '../modules/shop/discount/Index.vue'
import DiscountEdit from '../modules/shop/discount/Edit.vue'

import CommercialGesture from '../modules/shop/commercial-gesture/Index.vue'
import CommercialGestureEdit from '../modules/shop/commercial-gesture/Edit.vue'

import ConfigTax from '../modules/config/tax/Index.vue'
import ConfigTaxEdit from '../modules/config/tax/Edit.vue'
import ConfigTaxImport from '../modules/config/tax/Import.vue'

import ConfigTag from '../modules/config/tag/Index.vue'
import ConfigTagEdit from '../modules/config/tag/Edit.vue'

import ConfigTaxType from '../modules/config/taxtype/Index.vue'
import ConfigTaxTypeEdit from '../modules/config/taxtype/Edit.vue'


import Shipping from '../modules/shop/shipping/Index.vue'
import ShippingEdit from '../modules/shop/shipping/Edit.vue'

import Invoicing from '../modules/invoicing/Index.vue'
import InvoicingDashboard from '../modules/invoicing/Dashboard.vue'
import Invoice from '../modules/invoicing/invoice/Index.vue'
import InvoiceEdit from '../modules/invoicing/invoice/Edit.vue'
import InvoiceImport from '../modules/invoicing/invoice/Import.vue'

import Order from '../modules/shop/order/Index.vue'
import OrderEdit from '../modules/shop/order/Edit.vue'
import OrderNew from '../modules/shop/order/Edit.vue'

import Media from '../modules/media/Index.vue'
import MediaImport from '../modules/media/Import.vue'

import ReservationEdit from '../modules/reservation/Edit.vue'
import Reservation from '../modules/reservation/Index.vue'

import AgendaMain from '../modules/agenda/Index.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/switch-scope',
            name: 'Switch',
            component: SwitchVue,
            meta: {
                clientIsOptional: true,
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            }
        },
        {
            path: '/media',
            name: 'media',
            component: Media,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'import',
                    name: 'media-import',
                    component: MediaImport,
                    meta: {
                        action: "import",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                }
            ]
        },
        {
            path: '/reservation',
            name: 'reservation',
            component: Reservation,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'new',
                    name: 'reservation-new',
                    component: ReservationEdit,
                    props: true,
                    meta: {
                        action: "new",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: ':id',
                    name: 'reservation-edit',
                    component: ReservationEdit,
                    props: true,
                    meta: {
                        action: "edit",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
            ]
        },
        {
            path: '/agenda',
            name: 'agenda',
            component: AgendaMain,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
            ]
        },
        {
            path: '/event',
            name: 'event',
            component: EventIndex,
            meta: {
                action: "index",
                authenticated: true,
                acl: ["weeboxcore.event.view"],
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'new',
                    name: 'event-new',
                    component: EventEdit,
                    meta: {
                        action: "new",
                        authenticated: true,
                        acl: ["weeboxcore.event.create"],
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: ':id',
                    name: 'event-edit',
                    component: EventEdit,
                    meta: {
                        action: "edit",
                        authenticated: true,
                        acl: ["weeboxcore.event.update"],
                        permissions: {
                            roles: ['user']
                        }
                    }
                }

            ]
        },
        {
            path: '/campaign',
            name: 'campaign',
            component: CampaignIndex,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'campaign-dashboard',
                    component: CampaignDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'audience',
                    name: 'audience',
                    component: Audience,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'audience-new',
                            component: AudienceEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'audience-edit',
                            component: AudienceEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'campaign',
                    name: 'campaign',
                    component: Campaign,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [

                        {
                            path: 'publication/:id',
                            name: 'campaign-publication',
                            component: CampaignPublicationDetail,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'new/:support',
                            name: 'campaign-new',
                            component: CampaignEdit,
                            meta: {
                                action: "email",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'campaign-edit',
                            component: CampaignEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'template',
                    name: 'template',
                    component: CampaignTemplate,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'template-new',
                            component: CampaignTemplateEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'template-edit',
                            component: CampaignTemplateEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        },
        {
            path: '/serevita',
            name: 'serevita',
            component: Serevita,
            meta: {
                action: "index",
                authenticated: true,
                acl: ["weeboxserevita.contract.view"],
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'serevita-dashboard',
                    component: SerevitaDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: ["weeboxserevita.contract.view"],
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'contract',
                    name: 'contract',
                    component: SerevitaContract,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxserevita.contract.view",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'contract-new',
                            component: SerevitaContractEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxserevita.contract.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'contract-edit',
                            component: SerevitaContractEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxserevita.contract.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'protractor',
                    name: 'protractor',
                    component: SerevitaProtractor,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxserevita.protractor.view",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'protractor-new',
                            component: SerevitaProtractorEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxserevita.protractor.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'protractor-edit',
                            component: SerevitaProtractorEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxserevita.protractor.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'protractor-link',
                    name: 'protractor-link',
                    component: SerevitaProtractorLink,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxserevita.protractorlink.view",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'protractor-link-new',
                            component: SerevitaProtractorLinkEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxserevita.protractorlink.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'protractor-link-edit',
                            component: SerevitaProtractorLinkEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxserevita.protractorlink.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'table',
                    name: 'table',
                    component: SerevitaTable,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxserevita.table.view",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'table-new',
                            component: SerevitaTableEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxserevita.table.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'table-edit',
                            component: SerevitaTableEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxserevita.table.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        },
        {
            path: '/contacts',
            name: 'contacts',
            component: Contacts,
            meta: {
                action: "index",
                authenticated: true,
                acl: ["weeboxcore.person.vue","weeboxcore.company.vue"],
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'contacts-dashboard',
                    component: ContactsDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: ["weeboxcore.person.vue","weeboxcore.company.vue"],
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'person',
                    name: 'person',
                    component: Person,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.person.view",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'import',
                            name: 'person-import',
                            component: PersonImport,
                            meta: {
                                action: "import",
                                authenticated: true,
                                acl: "weeboxcore.person.import",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'new',
                            name: 'person-new',
                            component: PersonEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.person.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'person-edit',
                            component: PersonEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.person.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'company',
                    name: 'company',
                    component: Company,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.company.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'company-new',
                            component: CompanyEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.company.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'company-edit',
                            component: CompanyEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.company.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        },
        {
            path: '/invoicing',
            name: 'invoicing',
            component: Invoicing,
            meta: {
                action: "index",
                authenticated: true,
                acl: "weeboxcore.invoice.vue",
                permissions: {
                    roles: ['user']

                }
            },
            children: [
                {
                    path: '',
                    name: 'invoicing-dashboard',
                    component: InvoicingDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.invoice.vue",
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'invoice',
                    name: 'invoice',
                    component: Invoice,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.invoice.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'invoice-new',
                            component: InvoiceEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.invoice.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'invoice-edit',
                            component: InvoiceEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.invoice.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'import',
                            name: 'invoice-import',
                            component: InvoiceImport,
                            meta: {
                                action: "import",
                                authenticated: true,
                                acl: "weeboxcore.invoice.import",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: '/fidelity',
            name: 'fidelity',
            component: Fidelity,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'fidelity-dashboard',
                    component: FidelityDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'account',
                    name: 'account',
                    component: FidelityAccount,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'account-new',
                            component: FidelityAccountEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'account-edit',
                            component: FidelityAccountEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        },
        /*
        {
            path: '/checkin',
            name: 'checkin',
            component: CheckinHome,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'reservation',
                    name: 'reservation',
                    component: Checkin,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'reservation-new',
                            component: CheckinEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'reservation-edit',
                            component: CheckinEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        },
        */
        {
            path: '/config',
            name: 'config',
            component: Config,
            meta: {
                action: "index",
                authenticated: true,
                acl: [
                    "weeboxcore.attribute.vue",
                    "weeboxcore.transporter.vue",
                    "weeboxcore.payment.vue",
                    "weeboxcore.tax.vue",
                    "weeboxcore.tag.vue",
                    "weeboxcore.scope.vue",
                    "weeboxcore.scopeopeninghour.vue",
                    "weeboxcore.schedule.vue",
                    "weeboxcore.slotable.vue",
                ],
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'config-dashboard',
                    component: ConfigDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: [
                            "weeboxcore.attribute.vue",
                            "weeboxcore.transporter.vue",
                            "weeboxcore.payment.vue",
                            "weeboxcore.tax.vue",
                            "weeboxcore.tag.vue",
                            "weeboxcore.scope.vue",
                            "weeboxcore.scopeopeninghour.vue",
                            "weeboxcore.schedule.vue",
                            "weeboxcore.slotable.vue",
                        ],
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'attribute',
                    name: 'attribute',
                    component: ConfigAttribute,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.attribute.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'attribute-new',
                            component: ConfigAttributeEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.attribute.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'import',
                            name: 'attribute-import',
                            component: ConfigAttributeImport,
                            meta: {
                                action: "edit",
                                acl: "weeboxcore.attribute.import",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'attribute-edit',
                            component: ConfigAttributeEdit,
                            meta: {
                                action: "edit",
                                acl: "weeboxcore.attribute.update",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'transporter',
                    name: 'transporter',
                    component: ConfigTransporter,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.transporter.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'transporter-new',
                            component: ConfigTransporterEdit,
                            meta: {
                                action: "new",
                                acl: "weeboxcore.transporter.create",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'transporter-edit',
                            component: ConfigTransporterEdit,
                            meta: {
                                action: "edit",
                                acl: "weeboxcore.transporter.update",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'invoice-template',
                    name: 'invoice-template',
                    component: ConfigInvoiceTemplate,
                    meta: {
                        action: "index",
                        acl: "weeboxcore.invoice-template.vue",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'invoice-template-new',
                            component: ConfigInvoiceTemplateEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.invoice-template.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'invoice-template-edit',
                            component: ConfigInvoiceTemplateEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.invoice-template.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'pdf-template',
                    name: 'pdf-template',
                    component: ConfigPdfTemplate,
                    meta: {
                        action: "index",
                        acl: "weeboxcore.pdf-template.vue",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'pdf-template-new',
                            component: ConfigPdfTemplateEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.pdf-template.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'pdf-template-edit',
                            component: ConfigPdfTemplateEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.pdf-template.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'payment',
                    name: 'payment',
                    component: ConfigPayment,
                    meta: {
                        action: "index",
                        acl: "weeboxcore.payment.vue",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'payment-new',
                            component: ConfigPaymentEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.payment.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'payment-edit',
                            component: ConfigPaymentEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.payment.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'queue',
                    name: 'queue',
                    component: ConfigQueue,
                    meta: {
                        action: "index",
                        acl: "weeboxcore.queue.vue",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: []
                },
                {
                    path: 'payment-condition',
                    name: 'payment-condition',
                    component: ConfigPaymentDeadline,
                    meta: {
                        action: "index",
                        acl: "weeboxcore.paymentCondition.vue",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'payment-condition-new',
                            component: ConfigPaymentDeadlineEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.paymentCondition.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'payment-condition-edit',
                            component: ConfigPaymentDeadlineEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.paymentCondition.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'rating',
                    name: 'rating',
                    component: ConfigRating,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'rating-new',
                            component: ConfigRatingEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'rating-edit',
                            component: ConfigRatingEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'tax',
                    name: 'tax',
                    component: ConfigTax,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.tax.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'tax-new',
                            component: ConfigTaxEdit,
                            meta: {
                                action: "new",
                                acl: "weeboxcore.tax.create",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'tax-edit',
                            component: ConfigTaxEdit,
                            meta: {
                                action: "edit",
                                acl: "weeboxcore.tax.update",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'tag',
                    name: 'tag',
                    component: ConfigTag,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.tag.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'tag-new',
                            component: ConfigTagEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.tag.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'tag-edit',
                            component: ConfigTagEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.tag.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'taxtype',
                    name: 'taxtype',
                    component: ConfigTaxType,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.taxtype.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'taxtype-new',
                            component: ConfigTaxTypeEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.taxtype.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'taxtype-edit',
                            component: ConfigTaxTypeEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.taxtype.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'branch',
                    name: 'branch',
                    component: ConfigBranch,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.branch.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'branch-new',
                            component: ConfigBranchEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.branch.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'branch-edit',
                            component: ConfigBranchEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.branch.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'calendar',
                    name: 'calendar',
                    component: Calendar,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.slotable.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'calendar-new',
                            component: CalendarEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.slotable.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'calendar-edit',
                            component: CalendarEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.slotable.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'opening-hours',
                    name: 'opening-hours',
                    component: OpeningHour,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.scopeopeninghour.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'opening-hours-new',
                            component: OpeningHourEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.scopeopeninghour.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'opening-hours-edit',
                            component: OpeningHourEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.scopeopeninghour.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                    ]
                },
                {
                    path: 'agenda',
                    name: 'agenda',
                    component: Agenda,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.agenda.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'agenda-new',
                            component: AgendaEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.agenda.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'agenda-edit',
                            component: AgendaEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.agenda.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                    ]
                },
                {
                    path: 'closure',
                    name: 'closure',
                    component: Closure,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.schedule.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'closure-new',
                            component: ClosureEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.schedule.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'closure-edit',
                            component: ClosureEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.schedule.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                    ]
                },
                {
                    path: 'scope',
                    name: 'scope',
                    component: Scope,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxcore.scope.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'scope-new',
                            component: ScopeEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxcore.scope.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'scope-edit',
                            component: ScopeEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxcore.scope.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'acl',
                    name: 'acl',
                    component: ConfigAuthorization,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "is_super_admin",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'acl-new',
                            component: ConfigAuthorizationCreate,
                            meta: {
                                action: "new",
                                acl: "is_super_admin",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':model',
                            name: 'acl-edit',
                            component: ConfigAuthorizationEdit,
                            meta: {
                                action: "edit",
                                acl: "is_super_admin",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
            ]
        },
        {
            path: '/pass',
            name: 'pass',
            component: Pass,
            meta: {
                action: "index",
                authenticated: true,
                acl: "weeboxcore.pass.vue",
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'new',
                    name: 'pass-new',
                    component: PassEdit,
                    meta: {
                        action: "new",
                        authenticated: true,
                        acl: "weeboxcore.pass.create",
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: ':id',
                    name: 'pass-edit',
                    component: PassEdit,
                    meta: {
                        action: "edit",
                        authenticated: true,
                        acl: "weeboxcore.pass.update",
                        permissions: {
                            roles: ['user']
                        }
                    }
                }

            ]
        },
        {
            path: '/pass-template',
            name: 'pass-template',
            component: PassTemplate,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: []
        },
        {
            path: '/shortlink',
            name: 'shortlink',
            component: Shortlink,
            meta: {
                action: "index",
                authenticated: true,
                acl: "weeboxcore.shortlink.vue",
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'new',
                    name: 'shortlink-new',
                    component: ShortlinkEdit,
                    meta: {
                        action: "new",
                        authenticated: true,
                        acl: "weeboxcore.shortlink.create",
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: ':id',
                    name: 'shortlink-edit',
                    component: ShortlinkEdit,
                    meta: {
                        action: "edit",
                        authenticated: true,
                        acl: "weeboxcore.shortlink.update",
                        permissions: {
                            roles: ['user']
                        }
                    }
                }

            ]
        },
        /*
        {
            path: '/banner',
            name: 'banner',
            component: Banner,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'dashboard',
                    component: BannerDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'area',
                    name: 'area',
                    component: BannerArea,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'area-new',
                            component: BannerAreaEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'area-edit',
                            component: BannerAreaEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'ad',
                    name: 'ad',
                    component: BannerAd,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'ad-new',
                            component: BannerAdEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'ad-edit',
                            component: BannerAdEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'template',
                    name: 'template',
                    component: BannerTemplate,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'template-new',
                            component: BannerTemplateEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'template-edit',
                            component: BannerTemplateEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                }
            ]
        },
         */
        {
            path: '/shop',
            name: 'shop',
            component: Shop,
            meta: {
                action: "index",
                authenticated: true,
                acl: [
                    "weeboxshop.order.vue",
                    "weeboxshop.brand.vue",
                    "weeboxshop.category.vue",
                    "weeboxshop.discount.vue",
                    "weeboxshop.commercialgesture.vue",
                    "weeboxshop.inventory.vue",
                    "weeboxshop.product.vue",
                    "weeboxshop.producttype.vue",
                    "weeboxshop.productoption.vue",
                    "weeboxshop.shipping.vue",
                    "weeboxshop.voucher.vue",
                    "weeboxshop.giftcard.vue",
                ],
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'shop-dashboard',
                    component: ShopDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: [
                            "weeboxshop.order.vue",
                            "weeboxshop.brand.vue",
                            "weeboxshop.category.vue",
                            "weeboxshop.discount.vue",
                            "weeboxshop.commercialgesture.vue",
                            "weeboxshop.inventory.vue",
                            "weeboxshop.product.vue",
                            "weeboxshop.producttype.vue",
                            "weeboxshop.productoption.vue",
                            "weeboxshop.shipping.vue",
                            "weeboxshop.voucher.vue",
                        ],
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'order',
                    name: 'order',
                    component: Order,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.order.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'order-new',
                            component: OrderNew,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.order.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'order-edit',
                            component: OrderEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.order.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'category',
                    name: 'category',
                    component: Category,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.category.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'category-new',
                            component: CategoryEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.category.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'import',
                            name: 'category-import',
                            component: CategoryImport,
                            meta: {
                                action: "import",
                                authenticated: true,
                                acl: "weeboxshop.category.import",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'category-edit',
                            component: CategoryEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.category.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'category-tree',
                    name: 'category-tree',
                    component: CategoryTree,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.category.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'category-new',
                            component: CategoryEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.category.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'category-edit',
                            component: CategoryEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.category.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'product',
                    name: 'product',
                    component: Product,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.product.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'product-new',
                            component: ProductEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.product.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'import',
                            name: 'product-import',
                            component: ProductImport,
                            meta: {
                                action: "import",
                                authenticated: true,
                                acl: "weeboxshop.product.import",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'product-edit',
                            component: ProductEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.product.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'inventory',
                    name: 'inventory',
                    component: Inventory,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.inventory.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'inventory-new',
                            component: InventoryEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.inventory.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'inventory-edit',
                            component: InventoryEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.inventory.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'product-type',
                    name: 'product-type',
                    component: ProductType,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.producttype.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'product-type-new',
                            component: ProductTypeEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.producttype.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'import',
                            name: 'product-type-import',
                            component: ProductTypeImport,
                            meta: {
                                action: "import",
                                authenticated: true,
                                acl: "weeboxshop.producttype.import",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'product-type-edit',
                            component: ProductTypeEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.producttype.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'product-option',
                    name: 'product-option',
                    component: ProductOption,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.productoption.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'product-option-new',
                            component: ProductOptionEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.productoption.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'product-option-edit',
                            component: ProductOptionEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.productoption.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'brand',
                    name: 'brand',
                    component: Brand,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.brand.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'brand-new',
                            component: BrandEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.brand.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'import',
                            name: 'brand-import',
                            component: BrandImport,
                            meta: {
                                action: "import",
                                authenticated: true,
                                acl: "weeboxshop.brand.import",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'brand-edit',
                            component: BrandEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.brand.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'shipping',
                    name: 'shipping',
                    component: Shipping,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.shipping.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'shipping-new',
                            component: ShippingEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.shipping.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'shipping-edit',
                            component: ShippingEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.shipping.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'voucher',
                    name: 'voucher',
                    component: Voucher,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.voucher.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'voucher-new',
                            component: VoucherEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.voucher.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'voucher-edit',
                            component: VoucherEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.voucher.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'discount',
                    name: 'discount',
                    component: Discount,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.discount.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'discount-new',
                            component: DiscountEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.discount.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'discount-edit',
                            component: DiscountEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.discount.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'giftcard',
                    name: 'giftcard',
                    component: Giftcard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.giftcard.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'giftcard-new',
                            component: GiftcardEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.giftcard.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'giftcard-edit',
                            component: GiftcardEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.giftcard.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'commercial-gesture',
                    name: 'commercial-gesture',
                    component: CommercialGesture,
                    meta: {
                        action: "index",
                        authenticated: true,
                        acl: "weeboxshop.commercialgesture.vue",
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'commercial-gesture-new',
                            component: CommercialGestureEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                acl: "weeboxshop.commercialgesture.create",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'commercial-gesture-edit',
                            component: CommercialGestureEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                acl: "weeboxshop.commercialgesture.update",
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js